import { ApiResponse } from "shared/Types/responseTypes"
import { http, getHeaders } from "shared/Helpers/http"
import ApiHelper from "shared/Helpers/ApiHelper"
import { IMonetaryAmount } from "shared/Types/appTypes"

export type UserWallet = Readonly<{
    id?: number
    uid?: string
    displayName: string
    statusLabel: string
    brandingLabel: string
    acquirer: {
        acquirerSetupId: number
    }
    balance: IMonetaryAmount
}>

export const getUserWallets = (
    token: string,
    userId?: number
): Promise<
    ApiResponse<{
        wallets: Array<UserWallet>
    }>
> => {
    return http(
        new Request(ApiHelper.path(`/users/${userId}/wallets`), {
            method: "get",
            headers: getHeaders({ token }),
        })
    )
}
